// @owners { team: patients }
import { Description, InlineAlert, XsSpacing } from '@alto/design-system';
import React from 'react';
import { PhoneNumber } from '../../phone-number/components/PhoneNumber';

export const FamilyMemberConsentAlert = () => {
  return (
    <InlineAlert
      borderless={true}
      type="warning"
    >
      <Description fontFamily="semibold">Adding adult family members</Description>
      <XsSpacing />
      <Description>
        Anyone 18 years or older will need to provide oral or written authorization to be added to your account. Please
        have them contact us directly at <PhoneNumber />.
      </Description>
    </InlineAlert>
  );
};
